/**
 * Plan helpers — single source of truth for plan tier checks across the brand UI.
 *
 * Why this exists: with the new Organisations layer, an invited member's
 * personal `user.plan` stays 'free' but their organisation can be on
 * brand_pro. Both fields must be checked everywhere we gate a Pro feature.
 *
 * Use these helpers instead of comparing `user.plan` directly.
 */

export function effectivePlan(user) {
  return user?.organisation_plan || user?.plan || "free";
}

export function isBrandPro(user) {
  const p = effectivePlan(user);
  return p === "brand_pro";
}

export function isBrandLiteOrPro(user) {
  const p = effectivePlan(user);
  return p === "brand_lite" || p === "brand_pro";
}
